import { render, staticRenderFns } from "./editShopSetting.vue?vue&type=template&id=2ad3d417"
import script from "./editShopSetting.vue?vue&type=script&lang=js"
export * from "./editShopSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports